// extracted by mini-css-extract-plugin
export default {"modalContent":"invite-user-modal_modalContent__9PEmw"};